export { default } from './CompassOutline'
